<template>
        <div class="grid grid-cols-7 gap-4 template-preview -mx-4-5"
             v-loading="loading">
            <div class="col-span-5 bg-gray-150">
                <div class="flex items-center justify-center h-full main-bg-light" style="min-height: 460px">
                    <div class="rounded p-2 relative py-10">
                        <div v-for="item in templateHelp.Items">
                            <div class="absolute z-50 cursor-help"
                                 :style="getStyle(item)">
                                <div class="ellipse-wrapper flex items-center justify-center"
                                     @mouseover="onEllipseMouseOver(item.ItemNumber)"
                                     @mouseleave="onEllipseMouseLeave()">
                                    <div
                                        class="ellipse-outer bg-primary-300 text-white flex items-center justify-center">
                                        <div class="ellipse-inner text-white flex items-center justify-center">
                                            <span>{{ item.ItemNumber }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="isValidUrl(templateHelp.WidgetHelpPicture)" style="width: 680px">
                            <img class="w-full h-auto object-contain" alt="Preview" :src="templateHelp.WidgetHelpPicture">
                        </div>
                        <template v-else>
                            <component
                                :is="templateHelp.WidgetHelpPicture"
                                class="w-64 h-48"
                            />
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-span-2 px-2 overflow-auto max-h-65vh">
                <div v-for="(item, index) in templateHelp.Items" :key="index">
                    <p class="main-text-color my-2">{{ item.ItemName }}</p>
                    <div class="flex break-normal p-1"
                         :class="{'bg-primary-100 rounded': item.ItemNumber === activeItemNumber}">
                        <b>{{ item.ItemNumber }}</b>.
                        <span class="mx-1 text-xs main-text-color">{{ item.ItemDescription }}</span>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
const ONE_REM_IN_PX = 16

export default {
    name: "template-preview-info",
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        templateHelp: {
            type: [Object, Array]
        },

    },
    data() {
        return {
            activeItemNumber: 0,
        }
    },
    methods: {
        getStyle(item) {
            return {
                'margin-top': +item.ItemPositionY * ONE_REM_IN_PX + 'px',
                'margin-left': +item.ItemPositionX * ONE_REM_IN_PX + 'px',
            }
        },
        onEllipseMouseOver(index) {
            this.activeItemNumber = index
        },
        onEllipseMouseLeave() {
            this.activeItemNumber = 0
        },
        isValidUrl (string) {
            let url;
            try {
                url = new URL(string);
            } catch (_) {
                return false;
            }
            return url.protocol === "http:" || url.protocol === "https:"
        }
    },
}
</script>
<style lang="scss" scoped>
.template-preview ::v-deep {
    .ellipse-wrapper {
        @apply w-9 h-9 rounded-full bg-primary-100;
        content: '';

        span {
            @apply hidden;
        }

        &:hover {
            span {
                @apply flex;
            }

            .ellipse-outer {
                @apply bg-primary;
            }
        }
    }

    .ellipse-outer {
        @apply w-5 h-5 rounded-full;
        content: '';
    }

    .ellipse-inner {
        @apply w-3 h-3 rounded-full bg-primary;
        content: '';
    }
}
</style>
